import type { RouteRecordRaw } from "vue-router";
import { isInvited } from "../guards";
import { auth } from "@/mixins/firebase";

export const userRoutes: RouteRecordRaw[] = [
  {
    path: "/user/register/:id",
    name: "register",
    // @ts-ignore TODO: convert view to typescript
    component: () => import("../../views/RegisterView.vue"),
    meta: {
      hideSidebar: true,
    },
    beforeEnter: [
      isInvited,
      async () => {
        try {
          await auth.signOut();
        } catch {}
      },
    ],
  },
  {
    path: "/users/me",
    name: "userMe",
    component: () => import("../../views/user/EditLoggedInUser.vue"),
    meta: {
      requiresAuth: true,
      pageHeader: "My account",
    },
  },
];
